import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BackButton } from "../../Assets/Categories/BackIcon.svg";

const BreadCrumbs = ({ title }) => {
  const navigate = useNavigate();
  const handleNavigate = (e) => {
    e.preventDefault();
    navigate(-1);
  };
  return (
    <div className="page-info-container flex-container flex-align-center">
      <div style={{ cursor: "pointer" }}>
        <BackButton onClick={handleNavigate} />
      </div>
      <div className="page-info flex-container flex-column">
        <h2 style={{ margin: "0px" }}>{title}</h2>
      </div>
    </div>
  );
};

export default BreadCrumbs;
